import type { Translate } from '@/utils/hooks/translation/useTranslation';

import type { OnlyNewPlanType } from '@/types/pricingTypes/planType';
import {
    AGENCY_PLAN,
    CUSTOM_PLAN,
    ENTERPRISE_PLAN,
    EXCEL_PLAN,
    LAUNCH_PLAN,
    SCALE_PLAN,
    TEAMS_PLAN
} from '@/types/pricingTypes/planType';
import { SubscriptionType } from '@/types/pricingTypes/subscriptionType';
import { UserMarketingType } from '@/types/userMarketingType';
import { SocialProfileCountType } from '@/components/pages/settings/subscription-invoices/PlanModal/Components/PlanCard/types';

import { SOCIAL_PROFILE_COUNT_OPTIONS } from '@/components/pages/settings/subscription-invoices/PlanModal/Components/PlanCard/const';

export function getNbProfiles(nbProfiles: number): SocialProfileCountType {
    if (nbProfiles === 0) {
        return 5;
    }

    if (nbProfiles > 30) {
        return '30+';
    }

    if (nbProfiles % 5 === 0) {
        return nbProfiles as SocialProfileCountType;
    }

    return (Math.ceil(nbProfiles / 5) * 5) as SocialProfileCountType;
}

export function getSocialProfileOptions(variant: OnlyNewPlanType, t: Translate) {
    if (![LAUNCH_PLAN, SCALE_PLAN, EXCEL_PLAN].includes(variant)) {
        return [];
    }

    return SOCIAL_PROFILE_COUNT_OPTIONS[variant].map((option) => ({
        label:
            option.value === '30+'
                ? t('pricing:max_nb_social_profiles')
                : t('pricing:social_profiles_count', { count: option.value }),
        value: option.value
    }));
}

export function calculateProfilesPlanItemQuantity(
    selectedValue: number,
    weight: number,
    maxQuantity: number
): number {
    if (typeof selectedValue !== 'number') {
        return maxQuantity;
    }

    const quantity = selectedValue / weight;
    return quantity <= maxQuantity ? quantity : maxQuantity;
}

export function hasCSMPlan(subscription: SubscriptionType, userMarket: UserMarketingType) {
    const hasCSMManager = !!userMarket?.data?.csm_manager?.email;
    return (
        subscription.product_key === ENTERPRISE_PLAN ||
        subscription.product_key === EXCEL_PLAN ||
        subscription.product_key === AGENCY_PLAN ||
        subscription.product_key === CUSTOM_PLAN ||
        (subscription.product_key === TEAMS_PLAN &&
            subscription.options?.profiles?.count_total >= 10) ||
        hasCSMManager
    );
}
